// AffiliateDataService.js
import { apiClient } from "./apiClient"; // <-- use your new Axios instance

class AffiliateDataService {

  getAllPayoutRequests(affCode) {
    return apiClient.get(`/affiliate-all-payout-requests?affCode=${affCode}`);
  }

  getAffiliateOrders(affCode) {
    return apiClient.get(`/affiliate-orders?affCode=${affCode}`);
  }

  getReferredUsers(affCode) {
    return apiClient.get(`/affiliate-reff-users?affCode=${affCode}`);
  }

  login(userName, passWord) {
    return apiClient.post("/affiliate-login", { userName, passWord });
  }

  forgot(email) {
    return apiClient.post("/affiliate-forgot-password", { email });
  }

  reset(token, passWord) {
    return apiClient.post("/affiliate-reset-password", { token, passWord });
  }

  register(userName, userEmail, userPhone, passWord, reffBy, userRole) {
    return apiClient.post("/affiliate-register", {
      userName,
      userEmail,
      userPhone,
      passWord,
      reffBy,
      userRole,
    });
  }

  savePaypal(paypalEmail, affCode) {
    return apiClient.post("/affiliate-update-paypal-email", {
      paypalEmail,
      affCode,
    });
  }

  requestPayout(affCode, payMethod) {
    return apiClient.post("/affiliate-request-payout", { affCode, payMethod });
  }

  affCurrentPayoutRequest(affCode) {
    return apiClient.post("/affiliate-current-payout-request", { affCode });
  }

  validateReffByCode(affCode) {
    return apiClient.post("/affiliate-validate-reff-by-code", { affCode });
  }

  activateAffiliateById(affId) {
    return apiClient.post("/affiliate-activate", { affId });
  }

  pullMemberData(memberId) {
    return apiClient.post("/affiliate-pull-member-data", { memberId });
  }
}

export default new AffiliateDataService();
